import { Injectable } from '@angular/core';
import { PlanningToolService } from './planning-tool.service';
import { UtilService } from './util.service';
import { environment } from '../../environments/local/environment';
import {AppActionItem, ApplicationDTO, ApplicationIds} from "ngx-heka-design-lib";
import {APP_CONFIGS} from "../models/appmenu";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  private hasApplicationAccess = true;

  constructor(private planningToolService: PlanningToolService,
              private translateService:TranslateService,
              private utilService: UtilService) {}

  setAppActionItemClickAction(appMenuItem: AppActionItem) {
    switch (appMenuItem.config.appId) {
      case ApplicationIds.CUSTOMER_PORTAL:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.hcp);
        };
        break;
      case ApplicationIds.HPLUS_SERVICE:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.mh2);
        };
        break;
      case ApplicationIds.OPERATOR:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.hpo);
        };
        break;
      case ApplicationIds.LEVEL_2:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.redirect.host);
        };
        break;
      case ApplicationIds.ELECTRICITY_CALCULATION_TOOL:
        appMenuItem.clickHandler = () => {
          this.planningToolService.openTool(ApplicationIds.ELECTRICITY_CALCULATION_TOOL);
        };
        break;
      case ApplicationIds.TENDER_TOOL:
        appMenuItem.clickHandler = () => {
          this.planningToolService.openTool(ApplicationIds.TENDER_TOOL);
        };
        break;
      case ApplicationIds.HPLUS_DONGLE:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.dongle);
        };
        break;
      case ApplicationIds.HPLUS_DONGLE_ADMIN:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.dongle_admin);
        };
        break;
      case ApplicationIds.REMOTE_ADMIN:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.remote_admin);
        };
        break;
      case ApplicationIds.REMOTE_DESKTOP:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.remote_desktop);
        };
        break;
      case ApplicationIds.OMS_TOOL:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.oms);
        };
        break;
      case ApplicationIds.STATUS:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.status);
        };
        break;
      case ApplicationIds.GO_APP_ADMIN:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.go);
        };
        break;
      case ApplicationIds.B2B_ONLINE:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.b2b);
        };
        break;
        case ApplicationIds.LEARN_WORLD:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.learn_world);
        };
        break;
        case ApplicationIds.AI_PLAN:
        appMenuItem.clickHandler = () => {
          this.utilService.goToLink(environment.links.applications.ai_plan);
        };
        break;
    }
  }

  setAppAccess(hasApplicationAccess: boolean) {
    this.hasApplicationAccess = hasApplicationAccess;
  }

  hasAppAccess() {
    return this.hasApplicationAccess;
  }

  generateApplicationMenu(applications: ApplicationDTO[]) {
    let appMenuItems: AppActionItem[] = []
    const unsortedMenuItems: AppActionItem[] = [];
    applications?.forEach(application => {
      const foundAppConfig = APP_CONFIGS.find(i => i.appId === application.id);
      if (foundAppConfig) {
        let appMenuItem = new AppActionItem(foundAppConfig, this.translateService.instant(foundAppConfig.translationTitle));
        this.setAppActionItemClickAction(appMenuItem);
        unsortedMenuItems.push(appMenuItem);
      }
    });

    appMenuItems = unsortedMenuItems.sort((a, b) => a.config.order - b.config.order);
    return appMenuItems
  }
}
